import React, { useState, useEffect } from 'react';
import { Smartphone } from 'lucide-react';
import { toast } from 'sonner';

const PWAInstallIcon = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showIcon, setShowIcon] = useState(false);

  useEffect(() => {
    // Listen for the beforeinstallprompt event
    const handler = (e) => {
      console.log('[PWA] Install prompt available');
      e.preventDefault();
      setDeferredPrompt(e);
      
      // Check if already installed
      const isInstalled = window.matchMedia('(display-mode: standalone)').matches;
      
      if (!isInstalled) {
        setShowIcon(true);
      }
    };

    window.addEventListener('beforeinstallprompt', handler);

    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      console.log('[PWA] App is running in standalone mode');
      setShowIcon(false);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      toast.info('Install option not available on this device');
      return;
    }

    // Show the install prompt
    deferredPrompt.prompt();

    // Wait for the user's response
    const { outcome } = await deferredPrompt.userChoice;
    console.log(`[PWA] User response: ${outcome}`);

    if (outcome === 'accepted') {
      console.log('[PWA] User accepted the install prompt');
      toast.success('App installed successfully!');
      setShowIcon(false);
    } else {
      console.log('[PWA] User dismissed the install prompt');
    }

    // Clear the deferred prompt
    setDeferredPrompt(null);
  };

  // Don't show icon if no prompt available or already installed
  if (!showIcon || !deferredPrompt) {
    return null;
  }

  return (
    <button
      onClick={handleInstallClick}
      className="fixed bottom-6 right-6 z-50 bg-accent hover:bg-accent/90 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2"
      title="Install App"
      aria-label="Install App"
    >
      <Smartphone className="h-6 w-6" />
    </button>
  );
};

export default PWAInstallIcon;
